<template>
  <div class="accout-overview-header">
    <el-row>
      <el-col :span="24">
        <div class="page-title">
          {{ $t('merchant.account_balance') }}
        </div>
      </el-col>
    </el-row>
    <div class="balance-content">
      <div>
        <div class="accout-overview-header-content">
          <div class="num-container">
            <div class="txt">{{ $t('merchantAccount.balance_available') }}
              <!-- <el-tooltip placement="top">
                <div slot="content" style="width: 300px">
                  <span>{{ $t('tips.dashboard_balance_question') }}</span>
                </div>
                <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
              </el-tooltip> -->
            </div>
            <div class="num">
              {{ balanceInfo.balance | toDivideWithDot }}
              <el-tooltip placement="bottom">
                <div slot="content">
                  <span>{{ $t('tips.dashboard_balance_number') }} {{ balanceInfo.available_withdraw | toDivideWithDot }}</span>
                </div>
                <span>  <svg-icon icon-class="icon-font-warning" class="icon-warning" /></span>
              </el-tooltip>

            </div>
          </div>
          <div class="line" />
          <div class="num-container">
            <div class="txt">{{ $t('merchantAccount.amount_in_transit') }}</div>
            <div class="num">
              {{ balanceInfo.fund_settlement_amount | toDivideWithDot }}
            </div>
          </div>
          <div class="line" />
          <div class="num-container">
            <div class="txt">{{ $t('merchantAccount.amount_adb') }}</div>
            <div class="num">
              {{ balanceInfo.adb_amount | toDivideWithDot }}
            </div>
          </div>
        </div>
      </div>
      <div class="balance-operate">
        <el-button type="info" v-if="withdrawInfo.withdraw_type === 1" plain @click="onClickWithDrawBtn">
          {{ $t('merchantAccount.cash_out') }}
        </el-button>
        <!-- <el-button type="info" plain @click="onClickTransBtn">
          {{ $t('data.transfer') }}
        </el-button> -->
        <div class="line2" />
        <div @click="onClickBalanceDetailTxt">
          <span class="balance-detail-txt">{{ $t('data.balance_details') }}</span>
        </div>
      </div>
    </div>
    <WithdrawModal ref="withdrawModalRef" :withdraw-fee="withdrawFee" :merchant-info="merchantInfo" :balance-info="balanceInfo" @get-merchant-info="getMerchantInfo" />
  </div>
</template>

<script>
import { fetchMerchantInfo } from '@/api/merchant-manage/merchant-manage'
import { fetchWithdrawType, fetchNeedSupplementStatus } from '@/api/system/system.js'
export default {
  name: 'Merchant_Withdraw_Recharge',
  components: {
    WithdrawModal: () => import('../Modal/WithdrawModal.vue')
  },
  data() {
    return {
      balanceInfo: { balance: 0 },
      withdrawStatus: '',
      merchantInfo: {},
      withdrawInfo: {},
      withdrawFee: null,
      isNeedSupplementStatus: false,
      merchant: this.$store.getters.userInfo.merchant ?? {}
    }
  },
  created() {
    this.getMerchantInfo()
    this.getWithdrawType()
    // this.getNeedSupplementStatus()
    // this.getWithdrawStatus()
  },
  methods: {
    getWithdrawStatus() {
      fetchWithdrawStatus().then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          this.withdrawStatus = data.withdraw_status
        }
      })
    },
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { code, data } = res
        if (code === 10000 && data) {
          this.withdrawInfo = data
        }
      })
    },
    getNeedSupplementStatus() {
      fetchNeedSupplementStatus().then(res => {
        const { code, data } = res
        if (code === 1) {
          this.isNeedSupplementStatus = data
        }
      })
    },
    getMerchantInfo() {
      fetchMerchantInfo().then(res => {
        if (res.code === 10000) {
          const { merchant = {}, balance } = res.data || {}
          const { merchant_basic_info, withdraw_fee_status } = merchant
          this.balanceInfo = balance || {}
          this.merchantInfo = { ...merchant_basic_info, withdraw_fee_status }
        }
      })
    },
    onClickBalanceDetailTxt() {
      this.$router.push({ name: 'Financial_Manage_Agent_Balance_Detail' })
    },
    onClickRechargeBtn() {
      this.$router.push({ name: 'Financial_Manage_Balance_Recharge' })
    },
    onClickWithDrawBtn() {
      // 判断是否美元商户，是则提示美元商户不能提现
      // if (this.$store.getters['user/userInfo'].basic_info.settlement_country_type === 1) {
      //   this.$message.warning('For non-peso withdrawal, please contact us!')
      //   return
      // }
      // if (this.isNeedSupplementStatus) {
      //   this.$message.warning('Supplementary information is not passed!')
      //   return
      // }
      // if (this.withdrawStatus !== 1) {
      //   this.$message.warning('You are not allowed to cash out')
      //   return
      // }
      this.$refs.withdrawModalRef.changModalStatus(true)
    },
    onClickTransBtn() {
      this.$refs.transModalRef.changModalStatus(true)
    }
  }
}
</script>
<style scoped lang="scss">

.accout-overview-header{
  padding-bottom: 32px;
  border-bottom: 1px solid #D3D7DF;
  &-content{
    .num-container{
      display: inline-block;
      margin-bottom: 14px;
      .txt{
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: #4B5567;
      }
      .num{
        font-size: 24px;
        font-weight: 600;  font-family: 'Inter-SemiBold';
        line-height: 1.2;
        color:  #3855F1;
      }
    }

  }
  .line{
    display: inline-block;
    margin:0 24px;
    width: 1px;
    height: 60px;
    background:#D3D7DF;
    vertical-align: -4px;
  }
  .line2{
    display: inline-block;
    margin:0 15px;
    width: 1px;
    height: 32px;
    background:#D3D7DF;
  }
  .balance-detail-txt{
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    color: #1D3A71;
    cursor: pointer;
    text-decoration: underline;
  }
}
.balance-content{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.balance-operate{
  display: flex;
  align-items: center;
}
.icon-question{
  font-size: 11px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
.icon-warning{
  font-size: 15px;
  position: relative;
  top: -4px;
  cursor: pointer;
}

</style>

